var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDinersSmall = function SvgDinersSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 16,
    fill: "#0079BE",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.303 4c2.257-.035 4.09 1.819 4.125 4.101v.036c-.07 2.247-1.868 4.066-4.125 4.066H9.858c-2.186-.036-3.95-1.855-3.95-4.066C5.839 5.927 7.53 4.072 9.682 4zm-1.34.713c-1.833 0-3.35 1.534-3.35 3.388s1.517 3.388 3.35 3.388 3.35-1.534 3.35-3.388-1.516-3.388-3.35-3.388m-.529 5.67C8.2 10.063 7.46 8.778 7.777 7.53a2.33 2.33 0 0 1 1.657-1.676zm1.058-4.529c1.234.32 2.01 1.57 1.693 2.817a2.31 2.31 0 0 1-1.693 1.712z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDinersSmall);
export default ForwardRef;